/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { serviceTypeIdGet } from '../fn/service-type/service-type-id-get';
import { ServiceTypeIdGet$Params } from '../fn/service-type/service-type-id-get';
import { ServiceTypeModel } from '../models/service-type-model';
import { ServiceTypeModelSearchResultModel } from '../models/service-type-model-search-result-model';
import { serviceTypePost } from '../fn/service-type/service-type-post';
import { ServiceTypePost$Params } from '../fn/service-type/service-type-post';
import { serviceTypeSearchServiceTypePost } from '../fn/service-type/service-type-search-service-type-post';
import { ServiceTypeSearchServiceTypePost$Params } from '../fn/service-type/service-type-search-service-type-post';

@Injectable({ providedIn: 'root' })
export class MDIServiceTypeService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `serviceTypeSearchServiceTypePost()` */
  static readonly ServiceTypeSearchServiceTypePostPath = '/ServiceType/SearchServiceType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceTypeSearchServiceTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  serviceTypeSearchServiceTypePost$Response(params?: ServiceTypeSearchServiceTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ServiceTypeModelSearchResultModel>> {
    return serviceTypeSearchServiceTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceTypeSearchServiceTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  serviceTypeSearchServiceTypePost(params?: ServiceTypeSearchServiceTypePost$Params, context?: HttpContext): Observable<ServiceTypeModelSearchResultModel> {
    return this.serviceTypeSearchServiceTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<ServiceTypeModelSearchResultModel>): ServiceTypeModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `serviceTypeIdGet()` */
  static readonly ServiceTypeIdGetPath = '/ServiceType/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceTypeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceTypeIdGet$Response(params: ServiceTypeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ServiceTypeModel>> {
    return serviceTypeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceTypeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  serviceTypeIdGet(params: ServiceTypeIdGet$Params, context?: HttpContext): Observable<ServiceTypeModel> {
    return this.serviceTypeIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<ServiceTypeModel>): ServiceTypeModel => r.body)
    );
  }

  /** Path part for operation `serviceTypePost()` */
  static readonly ServiceTypePostPath = '/ServiceType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `serviceTypePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  serviceTypePost$Response(params?: ServiceTypePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return serviceTypePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `serviceTypePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  serviceTypePost(params?: ServiceTypePost$Params, context?: HttpContext): Observable<string> {
    return this.serviceTypePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
